import { Labels } from '../../shared-components/global/labels';

Labels.set('ui-tabs', 'selectTab', 'Vali vahekaart');
Labels.set('ui-tabs', 'left', 'Kerige vasakule');
Labels.set('ui-tabs', 'right', 'Kerige paremale');
